module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_c('b', [_vm._v("So … You Want to Learn to Paper Piece")])]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "src": "images/pg5_1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Have you heard the term “machine paper piecing” and wondered exactly what it was? Have you seen those numbered patterns in books or magazines and wondered how to use them? Have you seen the perfect patchwork resulting from machine paper piecing and wondered if you could do that? Are you the type of person who prefers to be shown how rather than told how to accomplish a task? If you answered yes to any of these questions, then this is the book for you!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Machine paper piecing is a method that allows you to create accurate patchwork blocks quickly and easily. You simply cut oversize fabric pieces and sew them in sequence to a paper foundation. Even if you have never made a piece of patchwork before, you can make wonderful blocks the first time you try machine paper piecing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This booklet will show you how to machine paper piece, step by step. It does not contain everything there is to know about paper piecing. I’ve written many books on this subject. (See More Books on Machine Paper Piecing.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While you are learning how to paper piece, you can make the small quilt shown on the cover. Simply make nine 3˝ × 3˝ Heart blocks, sew them together, and add a border. There are a total of 16 paper foundations, so make some practice blocks first if you wish.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use this design or the patterns in Patterns chapter to trace or photocopy more Heart blocks when you use up the preprinted foundations included in this booklet.")]), _vm._v(" "), _c('p', {
    staticClass: "figure-aligncenter-indent"
  }, [_c('img', {
    attrs: {
      "src": "images/pg5_2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29442e7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0003_chapter-title-1.vue
// module id = 63
// module chunks = 0